/**
 * The links in the verification, password-reset and email-change emails
 * (server/pb_hooks/lib/auth-mail.js) open the app's confirm pages, which redeem the token here.
 */
import { pb } from "@/lib/platform/pocketbase";

export async function confirmVerification(token: string): Promise<void> {
  await pb.collection("users").confirmVerification(token);
  // Signed in on this device: pick up `verified` now, or inviting keeps refusing until a reload.
  if (pb.authStore.isValid)
    await pb
      .collection("users")
      .authRefresh()
      .catch(() => undefined);
}

/** The link in the email-change email; PocketBase asks for the password once more. */
export async function confirmEmailChange(token: string, password: string): Promise<void> {
  await pb.collection("users").confirmEmailChange(token, password);
}

/** Sends the confirmation email again (members tab, before the first invitation). */
export async function requestVerification(email: string): Promise<void> {
  await pb.collection("users").requestVerification(email);
}

export async function confirmPasswordReset(token: string, password: string): Promise<void> {
  await pb.collection("users").confirmPasswordReset(token, password, password);
}
